"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let PrinterConfig = class PrinterConfig extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    IPPVersions;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    config;
    resource;
    async $$load_resource() {
        return this.oid
            ? this.$fn.fetch('get_object_by_type', { parameters: { id: this.oid, object_type: 'printer' }, asResource: true })
            : new this.$fn.Resource(_.reduce(this.$data.config, (m, v, k) => _.set(m, k, _.get(v, 'default', null))));
    }
    editor;
    async $$load_editor() {
        return this.resource.editor();
    }
    selectedFile;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['IPPVersions', 'formId', 'formName', 'config', 'resource', 'editor', 'selectedFile', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                IPPVersions: ["1.0",
                    "1.1",
                    "2.0",
                    "2.1",
                    "2.2",
                ],
                formId: null,
                formName: "PrinterConfig",
                config: {
                    name: {
                        label: this.$fn.pgettext("PrinterConfig", "Printer Name"),
                        help: this.$fn.pgettext("PrinterConfig", "A friendly name for the printer to help identify it easily."),
                    },
                    uri: {
                        label: this.$fn.pgettext("PrinterConfig", "Printer URI"),
                        help: this.$fn.pgettext("PrinterConfig", "The network address of the printer (e.g., ipp://printer.local:631/printers/Office). Must be a valid URL."),
                        required: true,
                    },
                    proxy: {
                        label: this.$fn.pgettext("PrinterConfig", "Proxy"),
                        help: this.$fn.pgettext("PrinterConfig", "The URL of the proxy server, if any."),
                    },
                    ipp_user_name: {
                        label: this.$fn.pgettext("PrinterConfig", "IPP User Name"),
                        help: this.$fn.pgettext("PrinterConfig", "The username used for IPP (Internet Printing Protocol) authentication."),
                        required: true,
                    },
                    ipp_version: {
                        label: this.$fn.pgettext("PrinterConfig", "IPP Version"),
                        help: this.$fn.pgettext("PrinterConfig", "Specifies the IPP protocol version used for communication (default is 2.0)."),
                        required: true,
                        default: "2.0",
                    },
                    is_default: {
                        label: this.$fn.pgettext("PrinterConfig", "Set as Default Printer"),
                        help: this.$fn.pgettext("PrinterConfig", "Mark this printer as the default option for print jobs."),
                    },
                },
                resource: null,
                editor: null,
                selectedFile: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: [this.$fn.pgettext("PrinterConfig|Title", "Printer configuration"),
                ],
                icon: this.$config.settings.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_5474_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_5480_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data,
            },
        };
    }
    async act_1040167445267876_crud_5478_getActionArgs($event) {
        return {
            objectType: "object_by_type",
            op: "upsert",
            data: { ...this.editor.getData(), 'object_type': 'printer' },
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_1548630417156826_closeModal_5484_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_1548630417156826_request_5482_getActionArgs($event) {
        return {
            operation: "delete_object_by_type",
            data: this.resource.getData({ fields: ['id', 'etag'] }),
            parameters: {
                object_type: "printer",
            },
        };
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_2186679009640457_closeModal_5486_getActionArgs($event) {
        return {
            name: this.modalName,
        };
    }
    async evh_2186679009640457_clickPreventStop(event, scope) {
        return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_5474 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_5474_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_5473 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_5474,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_5473],
        });
        const act_2248226175642056_closeComponent_5476 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_5475 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_5476,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_5475],
        });
        const act_1040167445267876_closeModal_5480 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_5480_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_5479 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_5480,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_crud_5478 = new core_1.actions.CRUDAction({
            actionArgs: this.act_1040167445267876_crud_5478_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_5479],
        });
        const evh_1040167445267876_submit_5477 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_crud_5478,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_5477],
        });
        const act_1548630417156826_closeModal_5484 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1548630417156826_closeModal_5484_getActionArgs,
            events: [],
        });
        const evh_1548630417156826_success_5483 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeModal_5484,
            event: "success",
            displayName: "closeModal",
        });
        const act_1548630417156826_request_5482 = new core_1.actions.RequestAction({
            actionArgs: this.act_1548630417156826_request_5482_getActionArgs,
            displayName: "delete",
            events: [evh_1548630417156826_success_5483],
        });
        const evh_1548630417156826_clickPreventStop_5481 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_request_5482,
            event: "click.prevent.stop",
            displayName: "delete",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_5481],
        });
        const act_2186679009640457_closeModal_5486 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_2186679009640457_closeModal_5486_getActionArgs,
            events: [],
        });
        const evh_2186679009640457_clickPreventStop_5485 = new core_1.actions.EventHandlerImpl({
            action: act_2186679009640457_closeModal_5486,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_2186679009640457_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2186679009640457_clickPreventStop_5485],
        });
        return {
            act_7315092382398562_closeModal_5474,
            evh_7315092382398562_close_5473,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_5476,
            evh_2248226175642056_close_5475,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_5480,
            evh_1040167445267876_success_5479,
            act_1040167445267876_crud_5478,
            evh_1040167445267876_submit_5477,
            evh_1040167445267876_submit,
            act_1548630417156826_closeModal_5484,
            evh_1548630417156826_success_5483,
            act_1548630417156826_request_5482,
            evh_1548630417156826_clickPreventStop_5481,
            evh_1548630417156826_clickPreventStop,
            act_2186679009640457_closeModal_5486,
            evh_2186679009640457_clickPreventStop_5485,
            evh_2186679009640457_clickPreventStop,
            save: act_1040167445267876_crud_5478,
            delete: act_1548630417156826_request_5482,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], PrinterConfig.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], PrinterConfig.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], PrinterConfig.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], PrinterConfig.prototype, "onSize", null);
PrinterConfig = __decorate([
    (0, vue_property_decorator_1.Component)()
], PrinterConfig);
exports.default = PrinterConfig;
vue_property_decorator_1.Vue.component("PrinterConfig", PrinterConfig);
